"use client";
import {ModuleReadGuard} from "@/components/shared";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {UserTableConfig} from "@/data";
import {CustomerType} from "@/libs/enums/live";
import {getTableConfigWithAccess} from "@/libs/helper";
import type {NextPage} from "next";

interface IUsers {
  name: string;
  gender: string;
  parentName: string;
  phoneNo: string;
  destination: string;
  rfidNo: string;
  pickup: string;
  drop: string;
  userType: string;
  status: string;
}

export const Users: NextPage = function () {
  const {roleAccess, filterContext} = useNeoContext();
  const isEmployeeTracking =
    filterContext?.client?.customerType === CustomerType.EMPLOYEETRACKING;
  const showTransportColumn =
    filterContext?.client?.customerType === CustomerType.SCHOOL ||
    filterContext?.client?.customerType === CustomerType.INDIVIDUAL ||
    filterContext?.client?.customerType === CustomerType.COLLEGE;
  const data = getTableConfigWithAccess(roleAccess, UserTableConfig, "MC005");

  if (isEmployeeTracking) {
    if (!data.table.activeColumns.includes("empStopName")) {
      const actionsIndex = data.table.activeColumns.indexOf("actions");
      data.table.activeColumns.splice(
        actionsIndex,
        0,
        "empStopName",
        "empCategoryName"
      );
    }
  } else {
    data.table.columns = data.table.columns.filter(
      (col: {uid: string}) =>
        col.uid !== "empStopName" && col.uid !== "empCategoryName"
    );
  }

  if (!showTransportColumn) {
    data.table.columns = data.table.columns.filter(
      (col: {uid: string}) => col.uid !== "transport"
    );
  }

  // Employee tracking: "+" opens the parent user form directly (no popup),
  // and the User Type column / filter are hidden
  const table = isEmployeeTracking
    ? {
        ...data.table,
        meta: {...data.table.meta, hasFilter: false},
        innerFilters: data.table.innerFilters?.filter(
          (f: {uid: string}) => f.uid !== "usersType"
        ),
        url: {
          ...data.table.url,
          page: {...data.table.url.page, addOptions: undefined}
        }
      }
    : data.table;

  return (
    <ModuleReadGuard moduleCode="MC005">
      <div className="flex min-h-[calc(100vh-63px)] w-full flex-col px-5 py-5">
        {/* <div className="mb-4 flex-row px-3">
          <NeoHeader message={data.title}></NeoHeader>
        </div> */}
        <div className="flex-row">
          {/*<NeoTable table={data.table}></NeoTable>*/}
          <NeoAGgrid table={table}></NeoAGgrid>
        </div>
      </div>
    </ModuleReadGuard>
  );
};
